"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThreeMediaRightBottomTextLayout = void 0;
var _editorialFetching = require("@ori/editorial-fetching");
var _presentationHooks = require("@ori/presentation-hooks");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _utils = require("../../utils");
var _shared = require("../shared");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const ThreeMediaRightBottomTextLayout = ({
  banner,
  debug,
  modulePosition,
  className
}) => {
  const isMobile = (0, _presentationHooks.useIsMobile)();
  const {
    modules,
    layout
  } = banner;
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  if (!modules || modules.length < 1) {
    return (0, _utils.getModulesLengthError)({
      debug,
      layout,
      modulePosition
    });
  }
  const [largeImage, smallImageLeft, smallImageRight, textArea] = modules;
  const textComponent = /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ContentWrapper, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_shared.TextBox, {
      module: textArea,
      titleMaxLines: isMobile ? 5 : 4
    })
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    className: className,
    "data-testid": getTestId(_editorialFetching.EditorialBannerLayoutEnum.ThreeMediaRightBottomText),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Inner, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_shared.ImageBox, {
        id: _constants.LARGE_IMAGE,
        module: largeImage,
        imageParams: _constants.LARGE_IMAGE_PARAMS.params,
        sizes: _constants.LARGE_IMAGE_PARAMS.sizes,
        height: _constants.LARGE_IMAGE_DESKTOP_HEIGHT,
        width: _constants.LARGE_IMAGE_DESKTOP_WIDTH
      }), isMobile ? textComponent : null, /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.SmallImagesWrapper, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_shared.ImageBox, {
          id: _constants.SMALL_IMAGE_LEFT,
          module: smallImageLeft,
          imageParams: _constants.SMALL_IMAGE_PARAMS.params,
          sizes: _constants.SMALL_IMAGE_PARAMS.sizes,
          height: _constants.SMALL_IMAGE_DESKTOP_WIDTH,
          width: _constants.SMALL_IMAGE_DESKTOP_WIDTH
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_shared.ImageBox, {
          id: _constants.SMALL_IMAGE_RIGHT,
          module: smallImageRight,
          imageParams: _constants.SMALL_IMAGE_PARAMS.params,
          sizes: _constants.SMALL_IMAGE_PARAMS.sizes,
          height: _constants.SMALL_IMAGE_DESKTOP_WIDTH,
          width: _constants.SMALL_IMAGE_DESKTOP_WIDTH
        })]
      })]
    }), isMobile ? null : textComponent]
  });
};
exports.ThreeMediaRightBottomTextLayout = ThreeMediaRightBottomTextLayout;
